export enum LicenseType {
  Chorus = "Chorus",
  TLE_Creator = "TLE_Creator",
  TLE_Teacher = "TLE_Teacher",
  Chorus_Optoma = "Chorus_Optoma"
}

export interface License {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  organizationId: string;
  expireAt: Date | null;
  metadata: Record<string, unknown>;
  licenseType: LicenseType;
  maxUsers: number;
  _count: {
    users: number;
  };
}

export interface LicenseIdAndAmount {
  licenseId: number;
  amount: number;
}

export interface LicenseProduct {
  id: string;
  price: number;
  translation_key: string;
  days: number;
}

export interface LicenseInvoiceData {
  message: string;
  invoiceUrl: string;
}